import { defineAsyncComponent } from 'vue';
import Swal from 'sweetalert2';

const isFilled = (v: any) =>
	v !== null && v !== undefined && String(v).trim() !== '';

export const isAppointmentDrugLocked = (data: any) =>
	isFilled(data?.nurse) &&
	(!!data?.is_patient_own || isFilled(data?.fact_mark));

const forms = {
	edit: {
		panel: {
			width: '80%',
			modal: true
		},
		component: defineAsyncComponent(() => import('./forms/Edit.vue'))
	},
	list: {
		component: defineAsyncComponent(() => import('./forms/List.vue'))
	}
};

const onBeforeDelete = async function (data: any) {
	if (isAppointmentDrugLocked(data)) {
		await Swal.fire(
			'Запись заблокирована',
			'После отметки выполнения (расход/медсестра) удаление запрещено',
			'warning'
		);
		return false;
	}
	return true;
};

export default {
	forms,
	onBeforeDelete
};

/** Отдельная регистрация для журнала (тот же UI) */
export const appointmentDrugsJournal = {
	forms,
	onBeforeDelete
};
